import { PortalViewErrorBoundary } from '@vs/component/portal-view-error-boundary';
import { SpaRoutesByPathsConfig } from '@vs/shared-context/spa-path-config-provider';
import { memo } from 'react';

import { isLocalDevMode } from '../../constants';

function AppContentRoutes() {
  return (
    <PortalViewErrorBoundary enable={!isLocalDevMode}>
      <SpaRoutesByPathsConfig />
    </PortalViewErrorBoundary>
  );
}

export default memo(AppContentRoutes);
